import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import type { ActionModuleScoreRangeResponse } from '@/api/model'

// Point tiers of a ScoreRange module (score range → points credited).
// Display only. `bare` = no border/title, when the caller frames the section itself.
export function ScoreRanges({ scoreRanges, bare = false }: { scoreRanges: ActionModuleScoreRangeResponse[]; bare?: boolean }) {
  const { t } = useTranslation('incentivation')
  return (
    <div className={bare ? '' : 'rounded-md border p-3'}>
      {!bare && <p className="mb-2 text-sm font-semibold">{t('scoreRanges.title')}</p>}
      {scoreRanges.length === 0 ? (
        <p className="text-sm text-muted-foreground">{t('scoreRanges.missing')}</p>
      ) : (
        <div className="flex flex-col gap-1 text-sm">
          <div className="grid grid-cols-[3rem_1rem_3rem_1.5rem_auto] items-center gap-2 text-xs font-medium text-muted-foreground">
            <span>{t('scoreRanges.from')}</span>
            <span />
            <span>{t('scoreRanges.to')}</span>
            <span />
            <span>{t('table.columns.points')}</span>
          </div>
          {scoreRanges.map((r, i) => (
            <div key={i} className="grid grid-cols-[3rem_1rem_3rem_1.5rem_auto] items-center gap-2">
              <span>{r.scoreFrom}</span>
              <span className="text-muted-foreground">–</span>
              <span>&lt; {r.scoreTo}</span>
              <ArrowRight className="size-4 text-muted-foreground" />
              <span className="font-medium">{r.pointsRewarded}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
